export default (state = { isLoading: false, pointsValue: 0 }, action) => {
  switch (action.type) {
    case 'LOAD_BALANCE':
      return { ...state, isLoading: true }
    case 'LOAD_BALANCE_SUCCESS':
      return { ...state, isLoading: false, ...action.payload.data }
    case 'LOAD_BALANCE_FAIL':
      return { ...state, isLoading: false, error: action.error.data }
    case 'LOAD_BALANCE_CACHED_SUCCESS':
      return { ...state, isLoading: false, pointsValue: action.payload.data }
    case 'LOAD_BALANCE_CACHED_FAIL':
      return { ...state, isLoading: false, error: action.error.data }
    default:
      return { ...state }
  }
}



// WEBPACK FOOTER //
// ./src/features/Balance/reducer.js